// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"76259bf4","513":"ed429c95","703":"e875ec30","787":"633816a4"}[chunkId] + ".chunk.js";
};